import { render, staticRenderFns } from "./MatchBets.vue?vue&type=template&id=7f3e0dca&scoped=true"
import script from "./MatchBets.vue?vue&type=script&lang=js"
export * from "./MatchBets.vue?vue&type=script&lang=js"
import style0 from "./MatchBets.vue?vue&type=style&index=0&id=7f3e0dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3e0dca",
  null
  
)

export default component.exports